/**
 * Model for API InvoiceLabel Model
 */
export class InvoiceLabel {
  /**
   * Pattern use to translate, keep but should not be used
   */
  pattern: string;

  /**
   * List of params use to translate, keep but should not be used
   */
  params: string[];

  /**
   * Translated value
   */
  translatedValue: string;

  constructor(attributes: Partial<InvoiceLabel> = {}) {
    Object.assign(this, attributes);
  }
}
